import { OpsResultsTable } from './Data'
import { useContext } from 'react'

import React from 'react'
import { Text, Tip } from 'grommet'
import { departments, getDepartmentForIdV2 } from '../api/retail'

import { AppContext } from '../libs/context'
import { labelByMode } from '../libs/common'

export const BulkScanTable = (props) => {
  const { receivers, stores, reasons, demoMode } = useContext(AppContext)

  return (
    <OpsResultsTable
      heading={labelByMode('nopickup', demoMode)}
      {...props}
      apiPath={'retail/bulkscan'}
      //   apiParams={{ receiver_type: 'HUB' }}
      apiFilters={
        [
          // {
          //   label: 'Search',
          //   field: 'search',
          //   placeholder: 'enter email or name'
          // },
          // {
          //   label: 'Receiver Type',
          //   field: 'receiver_type',
          //   options: ['HUB', 'FARM'],
          //   defaultValue: 'HUB'
          // },
          // {
          //   label: 'ID',
          //   field: 'id',
          //   placeholder: 'Enter an id'
          // }
          // {
          //   label: 'test',
          //   field: 'test',
          //   optionProps: { valueKey: 'id', labelKey: 'name' },
          //   options: departments,
          //   defaultValue: 2,
          //   placeholder: 'Enter an id'
          // }
        ]
      }
      renderResultWith={
        {
          //   ResultComponent: BulkScan,
          //   recordType: 'receiver',
          //   apiParams: { expand: ['store_set'] }
        }
      }
      showColumns={[
        {
          property: 'receiver_id',
          header: <Text weight={'bold'}>Receiver</Text>,
          render: ({ receiver_id }) => <Text>{(receivers[receiver_id] || {}).name}</Text>
        },
        {
          property: 'store',
          header: <Text weight={'bold'}>Store</Text>,
          render: ({ store }) => <Text> {store ? (stores[store] || {}).name : 'N/A'}</Text>
          //   render: ({ store }) => <Text>HIA</Text>
        },
        {
          property: 'reason_id',
          header: <Text weight={'bold'}>Reason</Text>,
          render: ({ reason_id }) => (
            <Text>{reason_id ? (reasons[reason_id] || {}).reason : 'N/A'}</Text>
          )
        },
        {
          property: 'destination_name',
          header: <Text weight={'bold'}>Destination</Text>
        },
        {
          property: 'department',
          header: <Text weight={'bold'}>Department</Text>,
          render: ({ department }) => <Text>{getDepartmentForIdV2(department)}</Text>
        },
        {
          property: 'creation_time',
          header: <Text weight={'bold'}>Date</Text>,
          render: ({ creation_time }) => (
            <Tip content={creation_time}>
              <Text>{new Date(creation_time).toDateString()}</Text>
            </Tip>
          )
        }
      ]}
    />
  )
}
